module.exports = __webpack_public_path__ + "img/support_e6.3026a42c.png";